const en = {
  header: {
    home: 'Home page',
    about: 'Brand concept',
    stores: 'Distribution of stores',
    help: 'Help center',
    members: 'Member center',
  }
}

export default en